const ticketFormFieldDropdownElement = {
  value: {
    label: "Valeur",
  },
};

export default ticketFormFieldDropdownElement;
